import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Product from '../components/Home/products/Product';
import Breadcrumb from '../components/ShearedComponents/Breadcrumb';
import emptyImg from "../assets/images/empty-cart.webp";
import { Link } from 'react-router-dom';

const WishList = () => {
    const { wishlist } = useSelector((state) => state.wishlist);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='pb-5'>
            <Breadcrumb page="Wishlist" />
            {
                wishlist.length > 0 ?
                    (
                        <div className='container mx-auto pb-5 pt-3 mb-5'>
                            <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  gap-4 '>
                                {wishlist.map((data, i) => (
                                    <Product key={i} product={data} />

                                ))}
                            </div>
                        </div>
                    )
                    :
                    (
                        <div className='h-full grid content-center justify-center text-center'>
                            <Link to="/">
                                <h3 className='text-xl font-poppins font-semibold hover:text-blue-700 cursor-pointer'>{"->"} Back to Home page {'<-'} </h3>
                            </Link>
                            <img className='object-contain' src={emptyImg} alt="" />
                        </div>
                    )
            }
        </div>
    );
};

export default WishList;